export { useFetchComparisonList } from '@dc-shared-web/hooks/api/comparison/useFetchComparisonList'
export { useFetchComparisonData } from '@dc-shared-web/hooks/api/comparison/useFetchComparisonData'
export { useCreateChangeNote } from '@dc-shared-web/hooks/api/comparison/useCreateChangeNote'
export { useUpdateChangeNote } from '@dc-shared-web/hooks/api/comparison/useUpdateChangeNote'
export { useDeleteChangeNote } from '@dc-shared-web/hooks/api/comparison/useDeleteChangeNote'

export { createChangeNote } from '@dc-shared-web/hooks/api/comparison/createChangeNote'
export { updateChangeNote } from '@dc-shared-web/hooks/api/comparison/updateChangeNote'
export { deleteChangeNote } from '@dc-shared-web/hooks/api/comparison/deleteChangeNote'
export { fetchComparisonData } from '@dc-shared-web/hooks/api/comparison/fetchComparisonData'

export type {
  VCCardProps,
  Note,
  ComparisonData,
  Change,
} from '@dc-shared-web/hooks/api/comparison/types'
export { useResolveChange } from '@dc-shared-web/hooks/api/comparison/useResolveChange'

export type { ResolveChangeParams } from '@dc-shared-web/hooks/api/comparison/resolveChange'
